import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from 'vue'
import { cn } from '@/lib/utils'
import { useSidebar } from './utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarRail',
  props: {
    class: {}
  },
  setup(__props: any) {

const props = __props

const { toggleSidebar } = useSidebar()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    "data-sidebar": "rail",
    "data-slot": "sidebar-rail",
    "aria-label": "Toggle Sidebar",
    tabindex: -1,
    title: "Toggle Sidebar",
    class: _normalizeClass(
      _unref(cn)(
        'hover:after:bg-sidebar-border absolute inset-y-0 z-20 hidden w-4 -translate-x-1/2 transition-all ease-linear group-data-[side=left]:-right-4 group-data-[side=right]:left-0 after:absolute after:inset-y-0 after:left-1/2 after:w-0.5 sm:flex',
        'in-data-[side=left]:cursor-w-resize in-data-[side=right]:cursor-e-resize',
        '[[data-side=left][data-state=collapsed]_&]:cursor-e-resize [[data-side=right][data-state=collapsed]_&]:cursor-w-resize',
        'hover:group-data-[collapsible=offcanvas]:bg-sidebar group-data-[collapsible=offcanvas]:translate-x-0 group-data-[collapsible=offcanvas]:after:left-full',
        '[[data-side=left][data-collapsible=offcanvas]_&]:-right-2',
        '[[data-side=right][data-collapsible=offcanvas]_&]:-left-2',
        props.class
      )
    ),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(toggleSidebar) && _unref(toggleSidebar)(...args)))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})